import { createSelector } from 'reselect';

export const getActivePopup = state => state.popup.first();

export const getPopupIsActive = createSelector(
	[ getActivePopup ],
	popup => !!popup
);
